import { render, staticRenderFns } from "./purchaseDetails.vue?vue&type=template&id=09549fd0&"
import script from "./purchaseDetails.vue?vue&type=script&lang=js&"
export * from "./purchaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./purchaseDetails.vue?vue&type=style&index=0&id=09549fd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports